export default "__VITE_ASSET__D$58JjR0__"